module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n  <div class=\"form-group\">\n    <span class=\"label label-md label-special-external\"\n      external-status-label\n      external=\"eventExternalCtrl.external\"></span>\n    <div class=\"text-center webinar-name-box\">\n      <span class=\"webinar-font\"> {{ eventExternalCtrl.external.webinarName || eventExternalCtrl.external.title }} </span><i ng-click=\"eventExternalCtrl.openManage()\" class=\"fa fa-lg fa-ellipsis-h  pull-right icon-style\"></i>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/eventManager/event/eventExternal/template.html
// module id = 1712
// module chunks = 0